// extracted by mini-css-extract-plugin
export var dropdownContainer = "_sb-0";
export var leftAlign = "_sb-4";
export var listItem = "_sb-2";
export var listItemWrapper = "_sb-1";
export var operationText = "_sb-3";